import { DAYS } from "@/externalDependecies/react-rrule-generator/constants"
import { POSTS } from "@/pages/allAnalytics/constants"
import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils"

export const tiktokFollowersGrowthConfig = [
    {
        plotName: "profile_followers",
        metricName: "profile_followers",
        sumMetrics: false,
        title: "analytics_growth.profile_followers",
        helpText: "analytics_growth.total_number_of_followers_tiktok",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "profile_followers",
        metricName: "profile_followers",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]


export const tiktokPlatformsGrowthConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.total_number_of_reactions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-thumbs-up",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "interactions",
        metricName: "comments",
        sumMetrics: false,
        title: "analytics_growth.comments_count",
        helpText: "analytics_growth.total_number_of_comments_tiktok",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "interactions",
        metricName: "shares",
        sumMetrics: false,
        title: "analytics_growth.shares",
        helpText: "analytics_growth.total_number_of_shares_tiktok",
        cssIcon: "fa-duotone fa-solid fa-share",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]


export const tiktokPlatformsGrowthPerPostConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.total_number_of_reactions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-thumbs-up",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS
    },
    {
        plotName: "interactions",
        metricName: "comments",
        sumMetrics: false,
        title: "analytics_growth.comments_count",
        helpText: "analytics_growth.total_number_of_comments_tiktok",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS
    },
    {
        plotName: "interactions",
        metricName: "shares",
        sumMetrics: false,
        title: "analytics_growth.shares",
        helpText: "analytics_growth.total_number_of_shares_tiktok",
        cssIcon: "fa-duotone fa-solid fa-share",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS
    }
]


export const tiktokPlatformsGrowthPerDayConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS
    },
    {
        plotName: "growth",
        metricName: "reactions",
        sumMetrics: false,
        title: "analytics_growth.reactions",
        helpText: "analytics_growth.total_number_of_reactions_tiktok",
        cssIcon: "fa-duotone fa-solid fa-thumbs-up",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS
    },
    {
        plotName: "interactions",
        metricName: "comments",
        sumMetrics: false,
        title: "analytics_growth.comments_count",
        helpText: "analytics_growth.total_number_of_comments_tiktok",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS
    },
    {
        plotName: "interactions",
        metricName: "shares",
        sumMetrics: false,
        title: "analytics_growth.shares",
        helpText: "analytics_growth.total_number_of_shares_tiktok",
        cssIcon: "fa-duotone fa-solid fa-share",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS
    }
]
